const NR = 0;
const RD = 1;
const RP = 2;

export const data = [
  { label: 'Non réparé', value: NR },
  { label: 'Réparé définitivement', value: RD },
  { label: 'Réparé partiellement', value: RP },
];

export default {
  NR,
  RD,
  RP,
  data,
};
